import * as React from "react"

import {navWidthMini} from "../../@signals";
import BaseDesktopDrawer from "./@BaseDrawer";


export default function AppMiniNavDrawer({ children, ...props }) {
    return <BaseDesktopDrawer { ...props} PaperProps={{
        ...props?.PaperProps,
        sx: {
            width: navWidthMini.value,
            ...props?.PaperProps?.sx,
        }
    }}>
        {children}
    </BaseDesktopDrawer>
}